import React from 'react';
import { Col } from 'antd';

/**
 * Col
 * --
 */
const ColComp = (props) => {
  /* Props */
  const {
    x = 12,
    children,
    style = {},
    alignvertical = null,
    xs = null,
    sm = null,
    md = null,
    lg = null,
    xl = null,
    xxl = null,
    padding = null,
  } = props;

  /*  */
  const alignCenterOption = {
    display: 'flex',
    ...(alignvertical && { alignItems: alignvertical }),
  };

  /* RENDER */
  return (
    <Col
      span={x}
      {...props}
      style={{
        ...style,
        ...(alignvertical && alignCenterOption),
        ...(xs && xs),
        ...(sm && sm),
        ...(md && md),
        ...(lg && lg),
        ...(xl && xl),
        ...(xxl && xxl),
        ...(padding && { padding }),
      }}
    >
      {children}
    </Col>
  );
};

export default ColComp;
